<template>
  <div v-if="!isStockOrder" data-qa="lease-company-details">
    <horizontal-line v-if="hasLeaseCompany" class="horizontalLine" />
    <h4 v-if="hasLeaseCompany">{{ i18n.t('/LeaseCompany/BlockTitle') }}</h4>
    <lease-company-details v-if="hasLeaseCompany" :company="company" />
    <search-lease-company-modal :show="showSearchModal" @close="showSearchModal = false" />
    <app-button
      v-if="hasLeaseCompany"
      data-qa="deselect-lease-company-button"
      button-class="action-quiet"
      :disabled="!isEditable"
      @click="deselectCompany()"
    >
      <svg
        width="15"
        height="15"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        aria-hidden="true"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
      <span>{{ i18n.t('/LeaseCompany/DeselectButton') }}</span>
    </app-button>
    <app-button
      v-else
      data-qa="search-lease-company-button"
      button-class="search-action"
      :disabled="!isEditable"
      @click="showSearchModal = true"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        aria-hidden="true"
      >
        <circle cx="11" cy="11" r="7"></circle>
        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
      </svg>
      <span>{{ i18n.t('/LeaseCompany/SearchButton') }}</span>
    </app-button>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import SearchLeaseCompanyModal from '@/components/generic/presentational/organisms/searchLeaseCompanyModal/SearchLeaseCompanyModal.vue'
import StoreConnector from '@/helpers/StoreConnector'
import LeaseCompanyDetails from '@/components/generic/presentational/molecules/leaseCompanyDetails/LeaseCompanyDetails.vue'
import { EventBus } from '@/plugins/event-bus'
import HorizontalLine from '@/components/generic/presentational/atoms/horizontalLine/HorizontalLine.vue'

export default {
  components: {
    AppButton,
    SearchLeaseCompanyModal,
    LeaseCompanyDetails,
    HorizontalLine,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showComponent: false,
      showSearchModal: false,
      viewmodel: null,
      company: null,
      hasLeaseCompany: false,
      isEditable: true,
      isStockOrder: false,
    }
  },
  created() {
    if (!window.VUE_CLI_EXPORTS.settings.FeatureSwitches.EnableLeaseCompanies) {
      this.showComponent = false
      return
    }
    StoreConnector.get('quote/leaseCompany', (data) => {
      this.hasLeaseCompany = data?.Name != null
      this.company = data
    })
    StoreConnector.get('viewmodels/get', (data) => {
      this.viewmodel = data ? data.customerDataContainer : null
    })
    StoreConnector.get('quote/hasCustomer', (data) => {
      this.showComponent = data
    })
    StoreConnector.get('quote/quoteStatusIsSalesOrder', (data) => {
      this.isEditable = !data
    })
    StoreConnector.get('quote/isStockOrder', (data) => {
      this.isStockOrder = data
    })
  },
  methods: {
    async deselectCompany() {
      await StoreConnector.dispatch('quote/resetLeaseCompany')
      EventBus.$emit('quote/leaseCompanyRemoved')

      StoreConnector.dispatch('quote/resetLeaseReference')
      EventBus.$emit('quote/leaseCompanyReference')
    },
  },
}
</script>

<style lang="scss" scoped>
h4 {
  margin-top: 1em;
}
</style>
